import { Field, Float, ID, InputType, ObjectType } from 'type-graphql'
import GraphQLJSON from 'graphql-type-json'
import { ActionArgs } from '@ztechapps/common.contract'
import type { IAction } from '@ztechapps/common.contract'

@InputType()
export class ExportResultsArgs extends ActionArgs {
  @Field(() => ID)
  assessmentId: string

  @Field(() => String)
  recipientEmail: string
}

@ObjectType()
@InputType('ExportResultsResultInput')
export class ExportResultsResult {
  @Field(() => Boolean)
  success: boolean

  @Field(() => String)
  message: string

  @Field(() => Float)
  resultsCount: number

  /**
   * Free-form class statistics object (totalStudents, classAverage,
   * highest/lowestScore, passRate, pendingReviewCount, …).
   */
  @Field(() => GraphQLJSON)
  statistics: any
}

export interface IExportResults extends IAction<ExportResultsResult, ExportResultsArgs> {}
